module.exports = __webpack_public_path__ + "static/img/icon-wechat-y.941143b9.png";